export const APP_NAME = "PT. Quamus Global Academy";
export const PERSIST_STORE_NAME = "Stvmp9dEsgRGTxaMz5BuZAQFNjV43XLfn7ecY8wHkrh6Kb2JWD";
export const REDIRECT_URL_KEY = "redirectUrl";